export function getView(iconOnly, type) {
  if (iconOnly || type === 'private') return 'No'

  return type === 'my-boards' ? 'MyBoards' : 'OtherBoards'
}
